import React, { Fragment } from 'react';

import useSearchTimeStandards from './UseSearchTimeStandards';
import useExpandedRow from '@usas/ui-web/components/grids/UseExpandedRow';

import LargeTimeStandardsGrid from './LargeTimeStandardsGrid';
import SmallTimeStandardsGrid from './SmallTimeStandardsGrid';

import global from '@usas/ui-web/components/GlobalStyle.module.css'

const TimeStandardsGrid = ({ onEditTimeStandard, onDeleteTimeStandard, onEditAgeGroup, onDeleteAgeGroup, searchTimeStandardState, onToggleFilters }) => {
  const { timeStandardState } = useSearchTimeStandards();
  const { onClick, expandedId } = useExpandedRow();

  return (
    <Fragment>
      {timeStandardState.isArrayLoading === false
      ? <div className="row">
        <div className="col-xs-12 col-sm-10">
          {timeStandardState.arrayData.length > 499
            ? <p className={global.ErrorMessage}>More than 500 Search Results returned. Please add additional filters to narrow your search results.</p>
            : <p>{timeStandardState.arrayData.length === 1 ? `${timeStandardState.arrayData.length} Search Result` : `${timeStandardState.arrayData.length} Search Results`}</p>}
        </div>
        {onToggleFilters ?
          <div className="col-xs-12 col-sm-2">
            <button className={global.ToggleButton} type="button" onClick={() => onToggleFilters()}>{searchTimeStandardState.showFilters === true ? 'Hide Filters' : 'Show Filters'}</button>
          </div> : <Fragment />}
      </div>
      : <Fragment>
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        </div>
      </Fragment >}
      <LargeTimeStandardsGrid
        state={timeStandardState}
        onEditTimeStandard={onEditTimeStandard}
        onDeleteTimeStandard={onDeleteTimeStandard}
        onEditAgeGroup={onEditAgeGroup}
        onDeleteAgeGroup={onDeleteAgeGroup}
        expandedId={expandedId}
        onClick={onClick}
      />
      <SmallTimeStandardsGrid
        state={timeStandardState}
        onEditTimeStandard={onEditTimeStandard}
        onDeleteTimeStandard={onDeleteTimeStandard}
        onEditAgeGroup={onEditAgeGroup}
        onDeleteAgeGroup={onDeleteAgeGroup}
        expandedId={expandedId}
        onClick={onClick}
      />
    </Fragment>
  )
};

export default TimeStandardsGrid;